import Range from '../rangeSlider/Range'

export default {
  name: 'smartFilter',
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isAjaxProcess: false,
      filter: {
        price: {
          from: 0,
          to: 0
        }
      }
    }
  },
  components: {Range},
  created: function () {
    for (const index in this.application.componentData.ITEMS) {
      if (this.application.componentData.ITEMS[index].PRICE) {
        if (+this.application.componentData.ITEMS[index].VALUES.MIN.HTML_VALUE >
          0) {
          this.filter.price.from = +this.application.componentData.ITEMS[index].VALUES.MIN.HTML_VALUE
        } else {
          this.filter.price.from = +this.application.componentData.ITEMS[index].VALUES.MIN.VALUE
        }
        if (+this.application.componentData.ITEMS[index].VALUES.MAX.HTML_VALUE >
          0) {
          this.filter.price.to = +this.application.componentData.ITEMS[index].VALUES.MAX.HTML_VALUE
        } else {
          this.filter.price.to = +this.application.componentData.ITEMS[index].VALUES.MAX.VALUE
        }
      }
    }
  },
  watch: {},
  methods: {
    priceRangeChange: function (sliderData) {
      this.filter.price.from = +sliderData.from
      this.filter.price.to = +sliderData.to
    },
    sendForm: function () {
      return this.$http.get(this.application.componentData.FILTER_AJAX_URL +
        '?ajax=y&' +
        window.$('#smart-filter').serialize())
    },
    applyForm: function () {
      this.sendForm().then(function (response) {
        console.log(response)
        if (response !== false) {
          window.location.href = response.data.SEF_SET_FILTER_URL
        }
      }).catch(function (error) {
        console.log(error)
        return false
      })
    },
    clearForm: function () {
      this.sendForm().then(function (response) {
        console.log(response)
        if (response !== false) {
          window.location.href = response.data.SEF_DEL_FILTER_URL
        }
      }).catch(function (error) {
        console.log(error)
        return false
      })
    },
    getAltName: function (smartFilterItem) {
      for (const value in smartFilterItem.VALUES) {
        return smartFilterItem.VALUES[value].CONTROL_NAME_ALT
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/components/smartFilter/script.js